import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { REGISTRATION_DATA_STAGES } from 'app-constants'
import {
  PhoneList,
  PhoneAdd,
  PhoneConfirmation,
  PhoneSuccess,
  PhoneDelete,
  PhoneSelectDefault,
} from './components'
import { ContactConfirmation } from '../../../contact-confirmation'

export function PhoneDrawer() {
  const [data, setData] = useState({})
  const { stage } = useSelector(({ drawer }) => drawer)

  return stages({ data, setData })[stage]
}

function stages({ ...props }) {
  return {
    initial: <PhoneList {...props} />,
    add: <PhoneAdd {...props} />,
    confirmation: <PhoneConfirmation {...props} />,
    success: <PhoneSuccess {...props} />,
    select_default: <PhoneSelectDefault {...props} />,
    delete: <PhoneDelete {...props} />,
    contact_confirmation: (
      <ContactConfirmation {...props} isPhone nextStage={REGISTRATION_DATA_STAGES.SUCCESS} />
    ),
  }
}
